import { Outlet } from 'react-router-dom';

/**
 * User Section Layout
 * Layout for user-scoped pages (profile, settings, preferences, etc.)
 */
export default function UserLayout() {
  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col gap-7 sm:gap-6">
      <Outlet />
    </div>
  );
}
